import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDeleteCompanyMutation} from 'api';
import {useSnackbar} from 'notistack';

function CompanyDeleteIconButton({companyId}) {
  const [deleteCompany, deleteCompanyResult] = useDeleteCompanyMutation();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();

  const handleDelete = async () => {
    try {
      await deleteCompany(companyId).unwrap();
      enqueueSnackbar('Company deleted', {variant: 'success'});
      setIsModalOpen(false);
    } catch (error) {
      const message = error.status === 400 ? error.data?.data : undefined;
      enqueueSnackbar(message || `Error deleting Company`, {variant: 'error'});
    }
  };

  return (
    <>
      <Dialog open={isModalOpen} maxWidth="xs">
        <DialogTitle>Delete Company</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this Company?</DialogContent>
        <DialogActions>
          <Button
            disabled={deleteCompanyResult.isLoading}
            autoFocus
            onClick={() => setIsModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={deleteCompanyResult.isLoading}
            color="error"
            endIcon={deleteCompanyResult.isLoading ? <CircularProgress size={16} /> : null}
            onClick={handleDelete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        onClick={() => setIsModalOpen(true)}
        disabled={deleteCompanyResult.isLoading}
        aria-label="delete"
        color="error"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
}

export default CompanyDeleteIconButton;
